import { apiRequest } from "./client";

export type PromptSettings = {
  id: number | null;
  persona: string;
  rules: string;
  edit_rules: string;
  note: string | null;
  created_at: string | null;
  created_by: number | null;
  created_by_username: string | null;
  /** True while nothing has been saved and the shipped defaults are in force. */
  is_default: boolean;
  max_chars: number;
  max_chars_token: string;
  /** The full prompt Gemini receives, with sample ticket data filled in. */
  preview: string;
};

export type PromptVersion = {
  id: number;
  persona: string;
  rules: string;
  edit_rules: string;
  note: string | null;
  created_at: string | null;
  created_by: number | null;
  created_by_username: string | null;
};

export type PromptSettingsUpdate = {
  persona: string;
  rules: string;
  edit_rules: string;
  note?: string | null;
};

export function getPromptSettings() {
  return apiRequest<PromptSettings>("/admin/settings/prompt");
}

export function updatePromptSettings(body: PromptSettingsUpdate) {
  return apiRequest<PromptSettings>("/admin/settings/prompt", {
    method: "PUT",
    body,
  });
}

export function resetPromptSettings() {
  return apiRequest<PromptSettings>("/admin/settings/prompt/reset", { method: "POST" });
}

export function listPromptVersions(limit = 50) {
  return apiRequest<{ items: PromptVersion[] }>("/admin/settings/prompt/versions", {
    query: { limit },
  });
}

export function restorePromptVersion(versionId: number) {
  return apiRequest<PromptSettings>(`/admin/settings/prompt/versions/${versionId}/restore`, {
    method: "POST",
  });
}
